// Vida en Orden — fuente de verdad ÚNICA para el estado de un gasto (JS).
// Espejo idéntico de /app/backend/status.py — mismos umbrales, mismo enum,
// mismos labels y emojis. Cualquier surface JS (Web, mobile) DEBE usar
// esta función — nunca hacer la comparación `due_date < today` inline.

const { todayInAR } = require('./isOverdue');

const LABELS = {
  vencido: 'VENCIDO',
  vence_hoy: 'VENCE HOY',
  proximo: 'PRÓXIMO',
  pagado: 'PAGADO',
  sin_fecha: 'SIN FECHA',
};

const EMOJIS = {
  vencido: '🔴',
  vence_hoy: '🟠',
  proximo: '🟡',
  pagado: '✅',
  sin_fecha: '⚪',
};

const _PRIORITY = {
  vencido: 0,
  vence_hoy: 1,
  proximo: 2,
  pagado: 3,
  sin_fecha: 4,
};

function expenseStatus(expense, now = new Date()) {
  if (!expense || typeof expense !== 'object') return 'sin_fecha';
  if (expense.paid) return 'pagado';
  const due = expense.due_date;
  if (!due || typeof due !== 'string') return 'sin_fecha';
  const dueDay = due.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dueDay)) return 'sin_fecha';
  const today = todayInAR(now);
  if (dueDay < today) return 'vencido';
  if (dueDay === today) return 'vence_hoy';
  return 'proximo';
}

function statusLabel(status) { return LABELS[status] || ''; }
function statusEmoji(status) { return EMOJIS[status] || ''; }
function statusPriority(status) { return _PRIORITY[status] ?? 99; }

module.exports = { expenseStatus, statusLabel, statusEmoji, statusPriority };
